<template>
  <success-page-layout
    store-badges-button-code="body-20210304-success-page-purchase"
    web-to-mobile-flag="webPremiumPurchased"
    :promote-app-download="true"
  >
    <template v-slot:content>
      <b-headline type="h1" typography="h2" class="mb-4 m:mb-6" v-html="$t('pages.success.headline')" />
      <p v-html="copy" />
    </template>

    <template v-slot:image>
      <purchase-image />
    </template>
  </success-page-layout>
</template>

<script>
import { getSearchParam } from "@/utils/location"
import formatDate from "@/utils/date-formatter"
import BHeadline from "@/component-library/b-headline"
import SuccessPageLayout from "@/pages/success-page/components/success-page-layout"
import PurchaseImage from "@/pages/success-page/components/purchase/image"
import { mapGetters } from "vuex"

export default {
  name: "PurchaseSuccess",
  components: {
    PurchaseImage,
    BHeadline,
    SuccessPageLayout
  },
  computed: {
    ...mapGetters(["usersEmail"]),

    trialEndDate() {
      const dateParam = parseInt(getSearchParam("trial_ending_at"))
      if (!dateParam) return null

      return formatDate(new Date(dateParam * 1000), this.$i18n.locale)
    },
    copy() {
      let copyKey = "copy.noTrial"
      if (this.trialEndDate) copyKey = "copy.trial"

      return this.$t(`pages.success.${copyKey}`, { trialEndDate: this.trialEndDate, usersEmail: this.usersEmail })
    }
  },
  mounted() {
    this.$store.dispatch("loadUsersAccounts")
  }
}
</script>
